import {
  findAllSiteMap,
} from '@bingads-webui-react/with-site-map';

export const getNavigateShortcutKeys = (siteMap) => {
  const result = [];
  const siteMapItems = findAllSiteMap(siteMap, item => item.shortcut);
  siteMapItems.forEach((item) => {
    result.push(item.shortcut);
  });
  return result.join(',');
};
